import { Icon, IconSizeClasses } from '@eppendorf/vnls-react-components';
import { useTranslation } from 'react-i18next';

import { Card } from '$components/card';
import { formatDurationFromSeconds } from '$features/report-hub/report-hub.utils';
import { DoorStats } from '$features/report-hub/stability-report/stability-report.types';

interface DoorStatsCardProps {
  door: DoorStats;
}

export function DoorStatsCard({ door }: DoorStatsCardProps) {
  const { t } = useTranslation();

  return (
    <Card className="p-xl m-bottom-l">
      <div className="flex flex__ai--center gap-s m-bottom-m">
        <Icon name="door-closed" size={IconSizeClasses.XSmall} className="bg-gray-900" />
        <span className="font-weight-semibold">{t('stabilityDetail.door.title')}</span>
      </div>
      <div className="flex flex__jc--space-between">
        <div className="flex flex__dir--column flex-1 gap-xs">
          <span className="color-gray-800 font-size-s">
            {t('stabilityDetail.door.totalOpenings')}
          </span>
          <span className="font-weight-semibold">{door.totalOpenings}</span>
        </div>
        <div className="flex flex__dir--column flex-1 gap-xs">
          <span className="color-gray-800 font-size-s">
            {t('stabilityDetail.door.totalOpenTime')}
          </span>
          <span className="font-weight-semibold">
            {formatDurationFromSeconds(door.totalOpenTime)}
          </span>
        </div>
        <div className="flex flex__dir--column flex-1 gap-xs">
          <span className="color-gray-800 font-size-s">
            {t('stabilityDetail.door.averageOpenDuration')}
          </span>
          <span className="font-weight-semibold">
            {formatDurationFromSeconds(door.averageOpenDuration)}
          </span>
        </div>
      </div>
    </Card>
  );
}
